import {
  Goal,
  getGoalCompletionProgress,
  getGoalProgressPercentage,
  incrementGoalCompletion,
} from '@akin-home/goals';
import { useUpdateGoalCompletion } from '@akin-home/goals/frontend';
import { useSendChatBackgroundMessage } from '../../chat/hooks';

interface Params {
  user_id: string;
  date: Date;
}

export const useIncrementGoal = ({ user_id, date }: Params) => {
  const update = useUpdateGoalCompletion();
  const sendMessage = useSendChatBackgroundMessage();
  const key = { date, user_id };

  return async (goal: Goal, value = 1) => {
    const updated_goal = incrementGoalCompletion(goal, key, value);

    update(updated_goal);

    if (value > 0) {
      sendMessage('increment_goal', {
        context: {
          goal: {
            id: goal.id,
            title: goal.title,
            progress_count: getGoalCompletionProgress(updated_goal, key),
            progress_percentage: getGoalProgressPercentage(updated_goal, key),
            target: goal.completions_per_period,
          },
        },
      });
    }
  };
};
